import { FC } from 'react';

import { VideolyProductInformation } from './VideolyProductInformation';
import { VideolyVideoboxPlaceholder } from './VideolyVideoboxPlaceholder';

type Props = {
    baseProductCode: string;
};

export const VideolyWidget: FC<Props> = ({ baseProductCode }) => {
    return (
        <>
            <VideolyVideoboxPlaceholder />
            <VideolyProductInformation baseProductCode={baseProductCode} />
        </>
    );
};
